<script>
import { api } from '../../../firebase'
import EventsTable from './EventsTable'
import EventsFilter from './EventsFilter'
import LoadingView from '../utils/LoadingView'
import LoadingEventsTable from './LoadingEventsTable'
import moment from 'moment'

export default {
  name: 'Mobilizev2Events',
  components: {
    EventsTable,
    EventsFilter,
    LoadingView,
    LoadingEventsTable
  },
  data() {
    const now = moment()
    const tomorrow = moment(now)
      .set('day', now.day() + 1)
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)

    return {
      loadingState: {
        pending: false,
        data: [],
        error: null
      },
      eventsFilter: {
        data: {
          title: null,
          eventTypes: [],
          city: null,
          state: null,
          date: tomorrow.format('YYYY-MM-DD'),
          sponsorOrg: null,
          virtual: 'All'
        },
        filters: [{ key: 'start_date', comparator: '>=', value: tomorrow.unix() }]
      },
      demo: window.location.pathname === '/mobilizev2/demo/events',
      search: '',
      showEventsFilterDialog: false
    }
  },
  computed: {
    events() {
      return this.loadingState.data
    }
  },
  methods: {
    moment,
    async sync() {
      this.loadingState = {
        pending: true,
        data: [],
        error: null
      }
      this.$store.dispatch('startSpinner')
      try {
        let page = 1
        const perPage = 25
        let allTotal = 0
        let updatedTotal = 0
        let newTotal = 0
        while (true) {
          const response = await api.events.sync({
            newOnly: true,
            page,
            perPage
          })
          const { events, updatedEvents, newEvents } = response
          if (events.length === 0) {
            break
          }
          allTotal = allTotal + events.length
          updatedTotal = updatedTotal + updatedEvents.length
          newTotal = newTotal + newEvents.length
          this.$toast.success(
            `Successfully synced ${allTotal} events (${newTotal} new, ${allTotal -
              newTotal} old, ${updatedTotal} updated)`
          )
          page = page + 1
        }
        await this.$refs.eventsTable.reLoad()
      } catch (error) {
        this.loadingState.error = error
      } finally {
        this.loadingState.pending = false
        this.$store.dispatch('stopSpinner')
      }
    },
    async applyFilter(filters) {
      this.showEventsFilterDialog = false
      this.eventsFilter.filters = filters
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view">
    <v-row>
      <v-col sm="auto" md="auto" lg="auto" xl="auto">
        <h1>Events</h1>
      </v-col>
      <v-spacer />
      <v-text-field v-model="search" append-icon="search" label="Search by title or sponsor" />
      <v-col class="filter-button" sm="auto" md="auto" lg="auto" xl="auto">
        <v-dialog
          v-model="showEventsFilterDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          class="filter-dialogue"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" :disabled="loadingState.pending">
              <v-icon>filter_list</v-icon>
              Filter events
            </v-btn>
          </template>
          <events-filter
            @close-filter="showEventsFilterDialog = false"
            v-model="eventsFilter.data"
            @apply-filter="applyFilter"
          />
        </v-dialog>
      </v-col>
      <v-col sm="auto" md="auto" lg="auto" xl="auto">
        <v-btn color="primary" class="mini-hidden" :disabled="loadingState.pending" @click="sync">
          <v-icon left dark>sync</v-icon>
          Sync new events
        </v-btn>
      </v-col>
    </v-row>
    <loading-events-table
      ref="eventsTable"
      :loadingState.sync="loadingState"
      :search="search"
      :filters="eventsFilter.filters"
    />
  </div>
</template>

<style lang="scss">
.filter-button {
  margin-right: -10px;
}

.v-dialog--fullscreen {
  left: 250px !important;
}
</style>
